import Decimal from 'decimal.js';
export var multiplyNumber = function multiplyNumber(num, mulValue) {
  return new Decimal(num !== null && num !== void 0 ? num : 0).mul(mulValue !== null && mulValue !== void 0 ? mulValue : 0).toNumber();
};
export var divideNumber = function divideNumber(num) {
  var divValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return new Decimal(num !== null && num !== void 0 ? num : 0).div(divValue !== null && divValue !== void 0 ? divValue : 1).toNumber();
};
export var removeTrailingZerosSafe = function removeTrailingZerosSafe(num) {
  return parseFloat(num);
};
export var addNumbers = function addNumbers(num1, num2) {
  return new Decimal(num1 !== null && num1 !== void 0 ? num1 : 0).add(new Decimal(num2 !== null && num2 !== void 0 ? num2 : 0)).toNumber();
};
export var addNumbersList = function addNumbersList(firstNum) {
  for (var _len = arguments.length, restNums = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restNums[_key - 1] = arguments[_key];
  }

  return restNums.reduce(function (total, current) {
    return total.add(new Decimal(current !== null && current !== void 0 ? current : 0));
  }, new Decimal(firstNum !== null && firstNum !== void 0 ? firstNum : 0)).toNumber();
};
export var subtractNumbers = function subtractNumbers(a, b) {
  return new Decimal(a !== null && a !== void 0 ? a : 0).sub(new Decimal(b !== null && b !== void 0 ? b : 0)).toNumber();
};